import React from 'react';
import { Switch, useRouteMatch, Route } from 'react-router-dom';
import AdminFieldsAndTemplates from './fields-and-templates';
import AdminGeneral from './general';
import AdminValues from './values';
import MassUpdates from './mass-updates';
import { DefaultFieldsContainer } from './fields-and-templates/default-fields/DefaultFieldsContainer';

const Admin = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}/fields-and-templates`}>
        <DefaultFieldsContainer.Provider>
          <AdminFieldsAndTemplates />
        </DefaultFieldsContainer.Provider>
      </Route>
      <Route path={`${match.path}/values`}>
        <AdminValues />
      </Route>
      <Route path={`${match.path}/general`}>
        <AdminGeneral />
      </Route>
      <Route path={`${match.path}/mass-updates`}>
        <MassUpdates />
      </Route>
    </Switch>
  );
};

export default Admin;
